module.exports = __webpack_public_path__ + "static/media/Graphics_7.0a6b205b.png";